import React, { useState, useEffect } from 'react';
import LeftNavContainers from "./LeftNavContainers";
import NavLink from "./../components/Common/NavLink";
import 'bootstrap/dist/css/bootstrap.min.css';
import { useNavigate } from 'react-router-dom';
import { getLoginToken } from '../utils/utility';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

const BaseLayout = ({ children, routeToLeftNavMapping }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const userState = useSelector((state) => state.user);
  const { userInfo = {} } = userState;
  const token = getLoginToken();
  const [navKey, setNavKey] = useState('MAIN_LEFT_NAV');


  useEffect(() => {
    const currentPath = location.pathname;
    if (!token) {
      navigate('/login?r=' + currentPath);
    }
    const matchedNav = routeToLeftNavMapping.find((route) =>
      Object.keys(route).some((key) => currentPath.startsWith(key))
    );
    if (matchedNav) {
      // Extract the corresponding value
      const leftNavValue = Object.values(matchedNav)[0];
      setNavKey(leftNavValue);
    }
  }, [navigate, userInfo]);


  return (
    <div className="app-shell d-flex min-vh-100">
      {/* Left Sidebar */}
      <LeftNavContainers formKey={navKey} />

      {/* Main Content */}
      <div className="app-content flex-grow-1 d-flex flex-column">
        {/* Top Navbar */}
        <NavLink />
        {/* <nav className="navbar navbar-expand-lg navbar-light bg-light">
          <div className="container-fluid">
            <span className="navbar-brand">React App</span>
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarNav"
              aria-controls="navbarNav"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
          </div>
        </nav> */}

        {/* Page Content */}
        <main className="app-page-content">
          {children}
        </main>
      </div>
    </div>
  );
};

export default BaseLayout;
